import React from 'react';

export default class cajaTexto extends React.Component {

    componentDidUpdate = () => {
        this.validarAcciones();
    }

    validarAcciones = () => {
        const { id, attributes } = this.props;
        const component = this.refs[id];
        if (attributes.focus) component.focus();
    }

    handleFocus = (event) => event.target.select();

    render() {
        const { id, label, type, value, col, attributes, onChangeInput, onKeyPress, onBlur, labelEx, placeholder, inputClass } = this.props;
        const readOnlyAttr = attributes.readOnly ? { readOnly: 'readOnly' } : {};
        const keyPressAttr = onKeyPress ? { onKeyPress: onKeyPress } : {};
        const maxLength = attributes.maxLength ? attributes.maxLength : '';
        const minLength = attributes.minLength ? attributes.minLength : '';
        const pattern = attributes.pattern ? attributes.pattern : '';
        const min = attributes.min ? attributes.min : '';
        const max = attributes.max ? attributes.max : '';
        const stilo = { display: !!attributes.hidden ? attributes.hidden : 'unset' };
        const onblur = onBlur ? onBlur : () => { };
        const stiloEx = { display: labelEx ? 'unset' : 'none' };
        const colEx = labelEx && labelEx.trim().length > 0 ? 10 : 12;
        const inputClasses = inputClass ? `form-control ${inputClass}` : "form-control";

        return (
            <div className={`col-sm-${col} col-md-${col}`} style={stilo}>
                <div className="form-group">
                    <label htmlFor={id}>{label}</label>
                    <div className="row">
                        <div className={`col-sm-${colEx} col-md-${colEx}`}>
                            <input type={type} className={inputClasses} onChange={onChangeInput} onBlur={onblur} name={id} id={id} ref={id} maxLength={maxLength} minLength={minLength} pattern={pattern} {...readOnlyAttr} {...keyPressAttr} value={value} min={min} max={max} onFocus={this.handleFocus} placeholder={placeholder} />
                        </div>
                        <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2" style={stiloEx}>
                            <label htmlFor={id}>{labelEx}</label>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
